import { alpha } from '@mui/material';
import theme from '../../muiTheme';

const styles = {

    navbarContainer : {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'fixed', //change to sticky if you want content at top of navbar
        width: '100vw',
        zIndex: 1000,
        boxSizing: 'border-box',
        boxShadow: '0px 0px 15px 0px rgb(0 0 0/ 7%)',
    },

    customAppBar: {
        width: '100vw',
        position: 'static',
        left: '0px',
        padding: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(5px)',
        backgroundColor: alpha(theme.palette.background.card, 0.95),
        
        boxSizing: 'border-box'
    },
    profileContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-evenly'
    },
    logo: { 
        color: theme.palette.primary.main,
        marginRight: 15,
        marginTop: 10
    },
    typography: {
        color: theme.palette.grayDark, 
        cursor: 'pointer',
        fontSize: 40,
        [theme.breakpoints.down('sm')]: {
            fontSize: 32,
        }
    },
    titleLink: {
        textDecoration: 'none',
        color: theme.palette.grayDark,
        [theme.breakpoints.down('sm')]: {
            // position: 'absolute',
            // transform: 'translateX(-50%)'
        }
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.grayDark
    },
    searchBar: {
        marginLeft: '30px'
    },
    button: {
        margin: '0px 5px',
        [theme.breakpoints.down('sm')] : { //this works ??? 
            margin: '0px 0px',
        }
    },
     popUpOverlay: {
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '0px !important' //not a fan of !important but this styling keeps being overidden by the mui5 stack somewhere in their module
    },
    popUpBox: {
        zIndex: 1200,
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row'
    },
    searchButton: {
        borderRadius: '20px',
        background: theme.palette.primary.main,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        transition: '0.2s',
        cursor: 'pointer', 
        border: '0px solid transparent',
        '&:hover': { //not being picked up ?????
            padding: '15px'
        },
        marginLeft: '10px'
    }

}

export default styles; 